import React from "react";

const Pagination = ({ totalPages, currentPage, setCurrentPage }) => {
  return (
    <div className="d-flex justify-content-center pt-2 pb-2 m-2">
      {[...Array(totalPages)].map((_, i) => (
        <button
          key={i}
          className={`btn btn-sm mx-1 ${currentPage === i + 1 ? "btn-primary nudges_active_btn" : "btn-outline-primary nudges_notactive_btn"} border-0`}
          onClick={() => setCurrentPage(i + 1)}
        >
          {i + 1}
        </button>
      ))}
    </div>
  );
};

export default Pagination;
